import React, { FunctionComponent, PropsWithChildren } from 'react';

import * as OrbModal from '@yandex-360/orb-components/dist/components/Modal2';
import cn from 'classnames';

import css from './index.css';

export interface ModalProps extends PropsWithChildren<OrbModal.ModalProps> {
    size?: 'sm' | 'md' | 'lg' | 'xl';
    disableFixedOverlay?: boolean;
}

/**
 * @deprecated Используем Modal из орбиты непосредственно
 */
const Modal: FunctionComponent<ModalProps> = ({ size, className, disableFixedOverlay, ...props }) => {
    const fixedOverlayClass = disableFixedOverlay ? undefined : css.fixedOverlay;

    if (size) {
        return <OrbModal.Modal size={size} className={cn(className, fixedOverlayClass)} {...props} />;
    }

    return (
        <OrbModal.Modal className={cn(css.responsiveModal, css.important, fixedOverlayClass, className)} {...props} />
    );
};

export default Modal;
